import React, { Component } from "react"
import Button from "../Button"
import AppContext from "../../shared/AppContext"

import "./upsellModal.scss"
import { Helmet } from "react-helmet"

class Upsell extends Component {
  render() {
    return (
      <div className="upsell-modal-container" data-cy="upsell-modal-container">
        <Helmet>
          <title>Upgrade | ETR</title>
        </Helmet>
        <div className="upsell-modal-header">
          You do not have access to this page
        </div>
        <div className="upsell-modal-body">
          Upgrade your subscription to gain access to this and other exclusive
          ETR content.
          <Button
            className="upsell-modal-button"
            action={() =>
              this.props.openInquireModal(
                this.props.serviceType.UpgradePlan,
                "Upsell Modal: Inquire For Pricing Button"
              )
            }
            text="Inquire For Pricing"
            data-cy="upsell-modal-button"
          />
        </div>
      </div>
    )
  }
}

const UpsellWithContext = (props) => {
  return (
    <AppContext.Consumer>
      {({ openInquireModal, serviceType }) => {
        return (
          <Upsell
            {...props}
            openInquireModal={openInquireModal}
            serviceType={serviceType}
          />
        )
      }}
    </AppContext.Consumer>
  )
}

export default UpsellWithContext
